import React, { use, useEffect, useState } from "react";
import * as S from "./ModalContent.style";
import FlorenzToogle from "../../../../florenzComponents/florenzToogle";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import { useTranslation } from "react-i18next";
import ContentInfo from "../contentInfo/ContentInfo";
import ContentAccess from "../contentAccess";
import ContentEpisodes from "../contentEpisodes";
import ContentExtra from "../contentExtra";

function ModalContent ({
  content,
  setContentSelected
}) {  

    const {t, i18n: { language }} = useTranslation("global");  

  const [panelInfoToggle, setPanelInfoToggle] = useState(false);
  const [tabInfoAccessSelected, setTabInfoAccessSelected] = useState(1);
  const [tabExtraEpisodes, setTabsExtraEpisodes] = useState(1);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.keyCode === 27) {
        setContentSelected(null);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  const tabsInfoAccess = [
    {
      id: 1,
      name: t("globally.info")
    },
    {
      id: 2,
      name: t("globally.access")
    }
  ]

  const tabsExtraEpisodes = [
    {
      id: 1,
      name: t("globally.episodes")
    },
    {
      id: 2,
      name: t("globally.extraContent")
    }
  ]

  return (
    <S.ModalContent>
      <div className="modal-background" onClick={() => setContentSelected(null)}>
      </div>
      <div className="modal-container">
        <div className="title">
          <i className="title__icon icon zaia-icono-maia-vision"></i>
          <div className="title__text">
            {t("globally.seriesInfo")}
          </div>
        </div>
        <div className="panels">
          <div className="panels__left">
            <div className="header">
              <FlorenzToogle
                tabs={tabsInfoAccess}
                activeTab={tabInfoAccessSelected}
                setActiveTab={setTabInfoAccessSelected}
                color="#F2F2F2"
                backgroundColor="#FFFFFF"
                borderRadius="8px"
                sizeFont="0.8rem"
              />
            </div>
            <div className="content-info-access">
              {
                tabInfoAccessSelected === 1
                ? <ContentInfo
                  content={content}
                />
                : <ContentAccess
                  content={content}
                />
              }
            </div>
          </div>
          <div className="panels__right">
            <div className="header">
              <div className="toogle-container">
                <FlorenzToogle
                  tabs={tabsExtraEpisodes}
                  activeTab={tabExtraEpisodes}
                  setActiveTab={setTabsExtraEpisodes}
                  color="#F2F2F2"
                  backgroundColor="#FFFFFF"
                  borderRadius="8px"
                  sizeFont="0.8rem"
                />
              </div>
              {/* <div className="season">
                <FlorenzButton
                  type={""}
                  size="s"
                  text={"Temporada 1"}
                  widthComplete={true}
                />
              </div> */}
            </div>
            <div className="content-extra-episodes">
              {
                tabExtraEpisodes === 1
                ? <ContentEpisodes
                  content={content}
                />
                : <ContentExtra
                  content={content}
                />
              }
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="button-close">
            <FlorenzButton
              typeStyle={"secondaryWhite"}
              size="s"
              text={t("globally.close")}
              widthComplete={true}
              onClick={() => setContentSelected(null)}
            />
          </div>
        </div>
      </div>  
    </S.ModalContent>
  )

}

export default ModalContent;
